<template>
  <img :src="src" @error="onError" :data-zoomable="true" />
</template>

<script>
import mediumZoom from 'medium-zoom';
export default {
  name: 'zoomImage',
  data() {
    return {
      zoom: null,
    };
  },
  props: ['src'],
  methods: {
    onError() {
      this.$emit('error');
    },
  },
  destroyed() {
    this.zoom.close();
  },
  updated() {
    this.zoom = mediumZoom('[data-zoomable]');
  },
  mounted() {
    this.zoom = mediumZoom('[data-zoomable]');
  },
};
</script>
